import React from 'react';
import { PriceDisplay } from '../utils/currency';
import { trackAddToCart } from './MetaPixel';
export const Guarantee = () => {
  const handleBuyClick = (e: React.MouseEvent) => {
    trackAddToCart();
  };
  return <section className="py-12 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto" data-id="element-163">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-164">
        <div className="flex flex-col md:flex-row" data-id="element-165">
          <div className="md:w-1/3 bg-[#0C1B2A] text-white p-8 flex items-center justify-center" data-id="element-166">
            <div className="text-center" data-id="element-167">
              <div className="relative inline-block" data-id="element-168">
                <svg className="w-32 h-32 text-[#D4AF37]" viewBox="0 0 100 100" fill="none" data-id="element-169">
                  <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="5" data-id="element-170" />
                  <path d="M28 50L42 64L72 36" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" data-id="element-171" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-172">
                  <span className="font-serif font-bold text-xl" data-id="element-173">7 DÍAS</span>
                  <span className="text-sm" data-id="element-174">GARANTÍA</span>
                  <span className="text-sm" data-id="element-175">TOTAL</span>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-2/3 p-8" data-id="element-176">
            <h2 className="font-serif text-2xl font-bold text-[#0C1B2A] mb-4" data-id="element-177">
              Sin riesgo, sin preocupaciones
            </h2>
            <p className="text-lg mb-4" data-id="element-178">
              Si no sientes un cambio real en 7 días, te devolvemos tu dinero.
              Sin preguntas. Sin riesgo.
            </p>
            <p className="text-[#555555] mb-6" data-id="element-179">
              Estamos tan seguros de que esta guía transformará tu energía y la
              de tu familia que te ofrecemos una garantía total. Prueba los
              rituales, sigue los pasos, y si no ves resultados, simplemente
              escríbenos y te reembolsamos el 100%.
            </p>
            <div data-id="element-180">
              <a href="https://pay.hotmart.com/Y101890168S?checkoutMode=10" className="btn-purchase inline-block bg-[#0C1B2A] hover:bg-[#1A2A3A] text-white font-bold py-3 px-8 rounded-lg shadow-lg transition-colors duration-300 mb-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0C1B2A]" aria-label="Comprar ahora con garantía por once dólares con noventa y nueve centavos" onClick={handleBuyClick} data-id="element-181">
                Comprar ahora — $11.99
              </a>
              <PriceDisplay data-id="element-182" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};